/* 10-reasons page interactions. Ported from the Lovable ListicleTop.
   Data-attribute driven; re-inits on Shopify section load. */
(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-tenr-tabs]').forEach(function (box) {
      if (box.dataset.tenrTabsReady) return;
      box.dataset.tenrTabsReady = '1';
      var tabs = box.querySelectorAll('.tenr-tabs__tab');
      var panels = box.querySelectorAll('.tenr-tabs__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
        });
      });
    });
  }
  function initVideoLoops(root) {
    root.querySelectorAll('video[data-tenr-loop]').forEach(function (v) {
      if (v.dataset.tenrLoopReady) return;
      v.dataset.tenrLoopReady = '1';
      var parts = (v.getAttribute('data-tenr-loop') || '').split(',');
      var start = parseFloat(parts[0]);
      var end = parseFloat(parts[1]);
      if (isNaN(start) || isNaN(end)) return;
      v.addEventListener('loadedmetadata', function () { try { v.currentTime = start; } catch (e) {} });
      v.addEventListener('timeupdate', function () { if (v.currentTime >= end) { try { v.currentTime = start; } catch (e) {} } });
    });
  }
  function init(root) { var r = root || document; initTabs(r); initVideoLoops(r); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
